import store from '@/store'
import { computed } from 'vue'

/**
 * Composable para obtener los métodos de pago disponibles para abonos
 * Filtra los métodos que no son válidos (IDs 5, 8, 9)
 * 
 * @returns {Object} { metodosPago }
 */
export function usePagoMethods() {
    const metodosPago = computed(() => {
        const metodos = store.getters.getTeatro?.metodos_pago_abonos_bases || []
        return metodos.filter(m => ![5, 8, 9].includes(m.id))
    })

    return { metodosPago }
}
